export const PM_FILTER_ALL = 'all';

export const PM_QUEUE_PAGE_SIZE = 25;
export const PM_QUEUE_MOBILE_PAGE_SIZE = 5;

export const PM_SIDEBAR_ITEMS_IN_VIEW = 2;

/** Prefix for unit Select values that enroll a unit in PM on choose. */
export const PM_ENROLL_UNIT_PREFIX = 'enroll:';

export const displayPmMetaValue = (value: string | null | undefined): string => {
    const trimmed = value?.trim();
    return trimmed ? trimmed : '—';
};

const COMPACT_PM_UNITS: Record<string, string> = {
    hours: 'hrs',
    hour: 'hrs',
    hrs: 'hrs',
    miles: 'mi',
    kilometers: 'km',
    gallons: 'gal',
    gal: 'gal',
    liters: 'L',
    cycles: 'cycles',
    days: 'days',
    each: 'ea',
    ea: 'ea',
    count: 'count',
    counts: 'count',
};

/** Short UM for matrix headers and qty wells (`250 hrs`, `gal`, `ea`). */
export const compactPmUnitLabel = (unitOfMeasure: string | null | undefined): string => {
    const key = (unitOfMeasure || '').trim().toLowerCase().replace(/\s+/g, '_');
    if (!key) return '';
    if (COMPACT_PM_UNITS[key]) return COMPACT_PM_UNITS[key];
    return (unitOfMeasure || '').trim();
};
